const initialStateVendor = {
  vendor: [],
  update_vendor: false,
};

export default initialStateVendor;